import { Component, OnInit } from '@angular/core';
import {AnimationOptions} from "ngx-lottie";
import {BaseComponent} from "@menatcode/purpletree";

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent  extends BaseComponent implements OnInit {
  options: AnimationOptions = {
    path: './assets/images/lottie_loader.json',
  };

  ngOnInit(): void {
  }

  navigateToRoot(isCreate: boolean = false) {
    this.back();
    return;
  }

}
